const awsmobile = {
  'aws_project_region': 'ap-southeast-1',
  'aws_cognito_identity_pool_id': 'ap-southeast-1:80bad525-fbdf-4281-814d-08e823ea0c0f',
  'aws_cognito_region': 'ap-southeast-1',
  'aws_user_pools_id': 'ap-southeast-1_K6J6iY0pA',
  'aws_user_pools_web_client_id': 'gbu3s0mcrb98iql49q9nt8ord',
  'oauth': {}
}
export default awsmobile